import React, { Fragment } from 'react';
import {mapIni, map} from './map';
import {showMenu} from '../contextmenu/actions';
import {showPopup} from '../mapPopup/actions';
import { connect } from 'react-redux';
import { revGeoAddress } from '../reverseGeocoding/actions';
import { VECTOR_BASE_LAYER, getActiveLayer } from '../baseLayers/reducer';


class MapComponent extends React.Component {

	componentDidMount(){

		mapIni({
      mapID: this.props.mapID
    });
	}

	contextMenu (e) {
		e.preventDefault();
		this.props.contextMenuHandler([e.clientX, e.clientY]);
    
    	//	addMenu.popup(e.clientX, e.clientY);
	}

  clickHandler(e) {

    this.props.clickHandler(e);
  }

  componentDidUpdate(e) {

    map.setTarget(document.getElementById('map_ol'));
  }

	render() {

    let mapElements = [
      (<div key="map_ol" id="map_ol" onClick={this.clickHandler.bind(this)} onContextMenu={this.contextMenu.bind(this)}></div>)
    ];


    return (<Fragment>
  		{mapElements}
      </Fragment>
  	);
  }
}

const mapStateToPropsRes = (state) => {

  //'WMSlayer' 

  var activeLayer = getActiveLayer(state.baseLayers);

  return {
    mapID: 'map_ol',
    //reverse == mb on top. if vector baselayer active, reverse element order so OL are on top, otherwise vector baselayer will other OL functionality
    reverse: (activeLayer === VECTOR_BASE_LAYER)
  }
};

const mapDispatchToPropsRes = (dispatch) => {

  return {
    contextMenuHandler: data => {

      var coord = map.getCoordinateFromPixel(data);

      dispatch(showMenu({pixel: data, coord: [parseFloat(coord[0].toFixed(2)), parseFloat(coord[1].toFixed(2))]}));
    //  dispatch(revGeoAddress(coord));
    },
    clickHandler: data => {
      dispatch(showMenu(null));
      
    }
  };
};

const MapContainer = connect(
  mapStateToPropsRes,
  mapDispatchToPropsRes
)(MapComponent);



export default MapContainer;